var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (profiles, undefined) {
// iterate profiles.models
;(function(){
  var $$obj = profiles.models;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var profile = $$obj[$index];

var href = profile.get('owner_type') !== 'User' ? profile.href() : undefined
buf.push("<div class=\"settings-galleries-institutions__profile\"><a" + (jade.attr("href", href, true, true)) + (jade.attr("style", "background-image: url(" + (profile.icon().imageUrl('square')) + ");", true, true)) + " class=\"settings-galleries-institutions__profile__icon\"></a><div class=\"settings-galleries-institutions__profile__metadata\"><a" + (jade.attr("href", href, true, true)) + " class=\"settings-galleries-institutions__profile__metadata__name\">" + (jade.escape(null == (jade_interp = profile.related().owner.get('name')) ? "" : jade_interp)) + "</a><a" + (jade.attr("data-id", profile.id, true, true)) + " class=\"settings-galleries-institutions__profile__metadata__follow entity-follow js-entity-follow\"></a></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var profile = $$obj[$index];

var href = profile.get('owner_type') !== 'User' ? profile.href() : undefined
buf.push("<div class=\"settings-galleries-institutions__profile\"><a" + (jade.attr("href", href, true, true)) + (jade.attr("style", "background-image: url(" + (profile.icon().imageUrl('square')) + ");", true, true)) + " class=\"settings-galleries-institutions__profile__icon\"></a><div class=\"settings-galleries-institutions__profile__metadata\"><a" + (jade.attr("href", href, true, true)) + " class=\"settings-galleries-institutions__profile__metadata__name\">" + (jade.escape(null == (jade_interp = profile.related().owner.get('name')) ? "" : jade_interp)) + "</a><a" + (jade.attr("data-id", profile.id, true, true)) + " class=\"settings-galleries-institutions__profile__metadata__follow entity-follow js-entity-follow\"></a></div></div>");
    }

  }
}).call(this);
}.call(this,"profiles" in locals_for_with?locals_for_with.profiles:typeof profiles!=="undefined"?profiles:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;